import { useFormik } from 'formik'
import { FC, useMemo } from 'react'
import {
  ButtonType,
  ID,
  OptionsHelper,
  showAlert,
  showError,
} from '../../../../../../../_metronic/helpers'
import {
  Button,
  FormInput,
  FormSelect,
  IOption,
  LoadingIndicator,
  useModal,
} from '../../../../../../components'
import { gerarFatura } from '../../core/_requests'
import { GeraFaturaDto } from '../../core/_models'
import { gerarFaturaSchema } from './validation/gerarFaturaSchema'
import { useT } from '_metronic/i18n/Metronici18n'

interface IProps {
  atendimentos: ID[]
  empresa?: IOption<number>
  onClose: () => void
}

export const GerarFaturaModal: FC<IProps> = ({ atendimentos, empresa, onClose }) => {
  const { t } = useT()
  const { closeModal } = useModal()

  const formik = useFormik({
    initialValues: {
      empresa: empresa as IOption<number> | undefined,
      ano: undefined as IOption<number> | undefined,
      mes: undefined as IOption<string> | undefined,
      descricao: '',
    },
    validationSchema: useMemo(() => gerarFaturaSchema(t), [t]),
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        const data: GeraFaturaDto = {
          ano: values.ano?.value as number,
          mes: Number(values.mes?.value),
          atendimentos: atendimentos.map((id) => Number(id)),
          descricao: values.descricao,
        }
        await gerarFatura(values.empresa?.value as number, data)
        onClose()
        showAlert({ title: 'Sucesso', text: 'Fatura gerada com sucesso!', icon: 'success' })
        closeModal()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <div className='row'>
        <div className='col-lg-12'>
          <FormSelect
            formik={formik}
            name='empresa'
            fetchOptions={OptionsHelper.getOptionsEmpresasForFaturamento}
            entity='empresa'
            className='mb-3'
            isRequired
          />
        </div>
        <div className='col-lg-6'>
          <FormSelect
            formik={formik}
            name='mes'
            fetchOptions={OptionsHelper.getOptionsMeses}
            entity='mes'
            className='mb-3'
            isRequired
          />
        </div>
        <div className='col-lg-6'>
          <FormSelect
            formik={formik}
            name='ano'
            entity='ano'
            fetchOptions={OptionsHelper.getOptionsAnos}
            className='mb-3'
            isRequired
          />
        </div>
      </div>
      <FormInput formik={formik} name='descricao' entity='descricao' isRequired />

      <div className='d-flex justify-content-center mt-10'>
        <Button className='btn-secondary me-3' disabled={formik.isSubmitting} onClick={closeModal}>
          {t('common.cancel')}
        </Button>
        <Button type={ButtonType.Submit} className='btn-primary' disabled={formik.isSubmitting}>
          {formik.isSubmitting ? <LoadingIndicator /> : t('common.save')}
        </Button>
      </div>
    </form>
  )
}
